import React from 'react';
import styles from './GanttBar.module.css';

const GanttBar = ({ object, fontSize = '0.6rem' }) => {
    const fontStyle = { fontSize };
    const flightNoStyle = { fontSize: `calc(${fontSize} + 2px)` };

    return (
        <div className={styles.container} data-object-id={object.id}>
            <span className={styles.textBase} style={fontStyle}>{object.dep}</span>
            <span className={`${styles.textBase} ${styles.flightNo}`} style={flightNoStyle}>{object.flightNo}</span>
            <span className={`${styles.textBase} ${styles.arrival}`} style={fontStyle}>{object.arr}</span>
        </div>
    );
};

export default React.memo(GanttBar, (prev, next) =>
    prev.object.id === next.object.id &&
    prev.fontSize === next.fontSize
);
